import { FormData } from '../index'

type HandleFieldChange = (field: keyof FormData, value: string) => void

export const saveDateOfBirth = (
    obj: { field: string; value: string },
    handleFieldChange: HandleFieldChange
) => {
    handleFieldChange('dob', obj.value)
    return { success: true, error: '' }
}

export const saveEmail = (
    obj: { field: string; value: string },
    handleFieldChange: HandleFieldChange
) => {
    handleFieldChange('email', obj.value)
    return { success: true, error: '' }
}

export const savePhone = (
    obj: { field: string; value: string },
    handleFieldChange: HandleFieldChange
) => {
    handleFieldChange('telephone', obj.value)
    return { success: true, error: '' }
}

export const saveAddress = (
    obj: { field: string; value: string },
    handleFieldChange: HandleFieldChange
) => {
    const parts = obj.value.split(',').map(p => p.trim())
    handleFieldChange('address1', parts[0] || '')
    handleFieldChange('address2', parts.length > 3 ? parts[1] : '')
    handleFieldChange('city', parts.length > 3 ? parts[parts.length - 2] : parts[parts.length - 2] || '')
    handleFieldChange('postcode', parts[parts.length - 1] || '')
    return { success: true, error: '' }
}
